// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
function Button(Props) {
  var children = Props.children;
  var classNameOpt = Props.className;
  var kindOpt = Props.kind;
  var dataId = Props.dataId;
  var dataTestId = Props.dataTestId;
  var onClickOpt = Props.onClick;
  var selectedOpt = Props.selected;
  var sizeOpt = Props.size;
  var roundedOpt = Props.rounded;
  var hoverOpt = Props.hover;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var kind = kindOpt !== undefined ? kindOpt : /* Primary */0;
  var onClick = onClickOpt !== undefined ? onClickOpt : function (param) {};
  var selected = selectedOpt !== undefined ? selectedOpt : false;
  var size = sizeOpt !== undefined ? sizeOpt : /* Lg */3;
  var rounded = roundedOpt !== undefined ? roundedOpt : false;
  var hover = hoverOpt !== undefined ? hoverOpt : true;
  var style;
  switch (kind) {
    case /* Primary */0:
      style = "border border-solid border-accent bg-accent text-main rounded-custom";
      break;
    case /* Secondary */1:
      style = "border border-solid border-accent text-primary bg-main rounded-custom";
      break;
    case /* Tertiary */2:
      style = "border border-solid border-transparent text-accent rounded-custom";
      break;
    case /* Gray */3:
      style = selected ? "border border-solid border-black text-primary bg-main" : "border border-solid border-gray-200 text-primary bg-main";
      break;
    case /* Red */4:
      style = "border border-solid border-red-600 text-red-600";
      break;
    case /* Base */5:
      style = "border border-solid border-transparent text-primary bg-main";
      break;
  }
  var hoverStyle;
  switch (kind) {
    case /* Primary */0:
    case /* Secondary */1:
      hoverStyle = hover ? "dark-hover darker-active" : "";
      break;
    case /* Gray */3:
      hoverStyle = selected || !hover ? "" : "hover:border-gray-300";
      break;
    case /* Tertiary */2:
    case /* Red */4:
      hoverStyle = "";
      break;
    case /* Base */5:
      hoverStyle = hover ? "hover:border-gray-300" : "";
      break;
  }
  var tmp;
  switch (size) {
    case /* Xs */0:
      tmp = "text-base px-3 py-2";
      break;
    case /* Sm */1:
      tmp = "text-base px-4 py-4 font-medium";
      break;
    case /* Md */2:
      tmp = "text-lg px-4 py-4 font-medium";
      break;
    case /* Lg */3:
      tmp = "text-xl px-6 py-4 font-medium";
      break;
  }
  var tmp$1 = {
    className: Cn.make([className, CSS$Showside.prefix("flex items-center justify-center cursor-pointer text-center"), rounded ? CSS$Showside.prefix("rounded-custom") : "", CSS$Showside.prefix(style), CSS$Showside.prefix(hoverStyle), CSS$Showside.prefix("font-button"), CSS$Showside.prefix(tmp)]),
    onClick: onClick
  };
  var tmp$2 = size !== 2 ? undefined : {
    paddingTop: "13px",
    paddingBottom: "13px"
  };
  if (tmp$2 !== undefined) {
    tmp$1.style = Caml_option.valFromOption(tmp$2);
  }
  var tmp$3 = {
    children: React.createElement("div", tmp$1, children)
  };
  if (dataTestId !== undefined) {
    tmp$3.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  if (dataId !== undefined) {
    tmp$3.dataId = dataId;
  }
  return React.createElement(DataAttribute$Showside.make, tmp$3);
}
Button.displayName = "Button";
var make = Button;
export { make };
/* react Not a pure module */